var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 5");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\uD83D\\uDCF1\\u2705-Investments-(I)",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Investment-switch---Accum---Current-investment-switch---D01",
  transform: "translate(-128.000000, -508.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(104.000000, 463.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(24.000000, 45.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFF0E0",
  cx: 20,
  cy: 20,
  r: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon/Quick-Actions/Investment-Change-Current-Balance---Scales",
  transform: "translate(8.000000, 8.000000)",
  fill: "#FF8200"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3,3 L3.612,4.836 C3.918,5.755125 4.778625,6.375 5.74725,6.375 L10.875,6.375 L10.875,8.715 C7.060125,9.26175 4.125,12.53325 4.125,16.5 L4.125,19.875 C4.125,20.496 4.629,21 5.25,21 L18.75,21 C19.371,21 19.875,20.496 19.875,19.875 L19.875,16.5 C19.875,12.53325 16.939875,9.26175 13.125,8.715 L13.125,6.375 L18.25275,6.375 C19.221375,6.375 20.080875,5.755125 20.386875,4.836 L21,3 L3,3 Z M14.25,15.375 C14.25,16.618125 13.243125,17.625 12,17.625 C10.756875,17.625 9.75,16.618125 9.75,15.375 C9.75,14.131875 10.756875,13.125 12,13.125 C13.243125,13.125 14.25,14.131875 14.25,15.375 Z",
  id: "Shape"
}))))));

var SvgCurrentBalance = function SvgCurrentBalance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCurrentBalance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/current-balance.b2f57899.svg";
export { ForwardRef as ReactComponent };